//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TelephoneInformationUpdateItem } from './TelephoneInformationUpdateItem';
import { IEmailUpdate } from './IEmailUpdate';

export class StudentProfileUpdateItem extends ItemBase implements IEmailUpdate {
    CanRegisterCancelEvent?: boolean;
    DateOfBirth?: string | null;
    EmailAddress?: string | null;
    EmailRemindersEnabled?: boolean;
    FaceTimeID?: string | null;
    FirstName?: string | null;
    LastName?: string | null;
    SkypeUsername?: string | null;
    SMSRemindersEnabled?: boolean;
    Telephone?: TelephoneInformationUpdateItem | null;

    constructor(initializer?: Partial<StudentProfileUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StudentProfileUpdateItem";
}
